module.exports = __webpack_public_path__ + "img/sms.4682b391.svg";